const cards = [
  {
    stat: "0",
    label: "verifiable timestamps",
    text: "Camera-roll photos carry no verifiable timestamps. They can be edited, re-saved, or re-dated — and the other side knows it.",
  },
  {
    stat: "#1",
    label: "deciding factor",
    text: "Deposit disputes hinge on documented condition. The party with structured, dated evidence almost always prevails.",
  },
  {
    stat: "AB 2801",
    label: "now the law in California",
    text: "California law now requires landlords to photograph rentals at move-in and before any deduction from a deposit.",
  },
];

export const Problem = () => (
  <section data-testid="problem-section" className="bg-[#F7F6F2] py-24 px-6 md:px-12">
    <div className="max-w-7xl mx-auto">
      <h2 className="font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#14213D] max-w-3xl">
        Deposit disputes are decided by evidence. Most people have none.
      </h2>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
        {cards.map((c, i) => (
          <div
            key={i}
            data-testid={`problem-card-${i}`}
            className="bg-white border border-[#2C3B5E]/20 rounded-xl p-8 shadow-sm transition-all duration-300 hover:border-[#C9A227]/50"
          >
            <p className="font-heading font-extrabold text-4xl text-[#8A6A00]">{c.stat}</p>
            <p className="mt-1 text-sm font-semibold uppercase tracking-wider text-[#14213D]">{c.label}</p>
            <p className="mt-4 text-sm text-[#5B6474] leading-relaxed">{c.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
